// `Intl.supportedValuesOf` is an ES2022 API not present in the project's ES2021 lib.
let timeZoneCityResolver;
/** Register the resource-owned city resolver used by time-zone label formatting. */ export function setTimeZoneCityResolver(resolver) {
    timeZoneCityResolver = resolver;
}
export function resolveTimeZoneCity(timeZone) {
    return timeZoneCityResolver?.(timeZone);
}
